import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NewsletterService} from "../../../shared/services/newsletter.service";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {NgForm} from "@angular/forms";
import {FilterService} from "../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Contract} from "../../../shared/interface/contract";
import {Newsletter} from "../../../shared/interface/newsletter";
import {delay, distinctUntilChanged, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {select, Store} from "@ngrx/store";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MassEditionDialogComponent} from "../../settlements/mass-edition-dialog/mass-edition-dialog.component";
import {NewsletterDetailsViewComponent} from "../newsletter-details-view/newsletter-details-view.component";
import {NewsletterPdfViewComponent} from "../newsletter-pdf-view/newsletter-pdf-view.component";

@Component({
  selector: 'app-newsletter-list',
  templateUrl: './newsletter-list.component.html',
  styleUrls: ['./newsletter-list.component.scss']
})
export class NewsletterListComponent implements OnInit, AfterViewInit, OnDestroy  {
  @Input() disableBreadcrumb = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @Input() displayedColumns: string[] = ['nr', 'newsName', 'createdAt', 'actions'];


  initialFilters: any;
  newsletters: Newsletter[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
      private newsletterService: NewsletterService,
      private filterService: FilterService,
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private auth: AuthService,
      private store: Store<StoreRootState>,
      private dialog: MatDialog,
      private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.newsletterService.getNewsletterListSubject()
        .pipe(
            takeUntil(this.destroyed$),
            tap((e: CountedAndPaginated<Newsletter>) => {
              this.newsletters = e.items;
              this.totalData = e.pagination.total;
            })
        ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.paginator.page
        .pipe(
            takeUntil(this.destroyed$)
        ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
        .pipe(
            select(getCurrentRouteState),
            delay(0),
            distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
            takeUntil(this.destroyed$),
        )
        .subscribe((state: RouterStateUrl) => {
          this.parseFilters(state.params);
          this.paginator.pageIndex = state.params.page;
          this.paginator.pageSize = state.params.pageSize;
          this.loadListData();
        })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      gte$createdAt: 'date',
      lte$createdAt: 'date',
      contains$newsletterName: 'string',
    }, filters);
  }
  loadListData(): void {
    this.newsletterService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }
  buildFilters(): any {
    const filters = {...this.initialFilters};


    return filters;
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
  editNewsletter(newsletter: Newsletter): void {
  }
  deleteNewsletter(newsletter: Newsletter): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć newsletter?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.newsletterService.deleteNewsletter(newsletter.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto newsletter', '', {duration: 2000});
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas usuwania pliku wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }
  viewNewsletter(newsletter: Newsletter): void {
    const dialogRef = this.dialog.open(NewsletterPdfViewComponent, {
      width: '80vw',
      maxHeight: '90vh',
      data: {
        newsletterObject: newsletter
      },
    });

    dialogRef.afterClosed().subscribe(() => this.loadListData());
  }
}
